<template>
    <div v-if="!showMenu & showMenu != 'undefined'">
   <div class="banner box-shadow">
       <div id="overlay"></div>
       <div class="box"><div class="content">Creative Services For Boost Your Learning Growth <br/>
   
       </div></div>

<!-- <div class="overlay-content">{{showTitle}}</div> -->

   </div>
   
    </div>
</template>

<script>
    export default {
        name:'BannerInner',
        data(){
          return {
            title : this.showTitle
          }
        },
        props:['PageTitle'],
        computed:{
           showMenu(){
                 return this.$store.state.auth.Menuhide
            },
            showTitle(){
                  return this.$props.PageTitle
            }

        },
          mounted() {
        this.showMenu
        

        },
        
    }
</script>

<style scoped>
.banner{
    background-image: url(../assets/bg-body3.png);
    background-repeat: no-repeat;
    background-position: bottom;
    height: 400px;
    padding: 50px;
    text-align: center;
    color: #fff;
    background-size: cover;
    position: relative;
     box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
     margin-top: 40px;
}

.banner .box{
  /* Auto layout */
  z-index: 900;
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 30px 30px;
gap: 10px;

position: absolute;
width: 419.15px;
    height: 257px;
    left: 197px;
    top: 138px;

background: rgba(255, 255, 255, 0.85);
backdrop-filter: blur(5.5px);
/* Note: backdrop-filter has minimal browser support */
border-radius: 29px;
}
.banner .box .content{


font-family: 'Cabin';
font-style: normal;
font-weight: 700;
font-size: 35px;
line-height: 116%;
/* or 58px */

color: #072D6C;
text-align: left;
}
.banner .box .content span{

font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 147.5%;
/* or 24px */

color: #595566;
}

#overlay {
position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0,0,0,0.1); /*dim the background*/
}

.overlay-content {
  position: relative;
  top: 18%; /* 25% from the top */
  width: 100%; /* 100% width */
  text-align: center; /* Centered text/links */
  margin-top: 30px; /* 30px top margin to avoid conflict with the close button on smaller screens */
  z-index: 333;
  font-size: 40px;
}
</style>